import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button } from 'react-bootstrap'
import { WizardSteps, MultiSelect } from '../../components'
import {
  pushPassingScore,
  getAssessmentsJson,
  pushAssessments,
  getChaptersJson,
  pushChapters,
} from '../actions'
import { linkPaths } from '../urls'

class Requirements extends React.Component {
  static propTypes = {
    updatePassingScore: PropTypes.func,
    passingScore: PropTypes.string.isRequired,
    selectedAssessments: PropTypes.array.isRequired,
    selectedChapters: PropTypes.array.isRequired,
    history: PropTypes.object,
    getAssessments: PropTypes.func,
    pushAssessmentsToStore: PropTypes.func,
    pushChaptersToStore: PropTypes.func,
    getChapters: PropTypes.func,
    assessments: PropTypes.object,
    chapters: PropTypes.array,
    retrievedEditData: PropTypes.bool.isRequired,
  }

  componentDidMount() {
    this.props.getChapters()
    this.props.getAssessments()
  }

  goBack = e => {
    e.preventDefault()
    let { history } = this.props
    history.push(linkPaths.design)
  }

  goNext = e => {
    e.preventDefault()
    let { history } = this.props
    history.push(linkPaths.review)
  }

  generateSelectField = () => {
    let scoreOptions = []
    for (var i = 1; i < 21; i++) {
      scoreOptions.push(
        <option value={i * 5} key={i * 5}>
          {i * 5}%
        </option>
      )
    }
    return (
      <select
        id="passing-score"
        onChange={this.handleSelectChange}
        value={this.props.passingScore}
        className="form-control"
      >
        {scoreOptions}
      </select>
    )
  }

  handleSelectChange = event => {
    this.setState({
      passingScore: event.target.value,
    })
    this.props.updatePassingScore(event.target.value)
  }

  handleAssessmentsChange = event => {
    if (event.target.checked) {
      this.props.pushAssessmentsToStore([
        ...this.props.selectedAssessments,
        event.target.value,
      ])
    } else {
      let selected = [...this.props.selectedAssessments]
      let index = selected.indexOf(event.target.value)
      selected.splice(index, 1)
      this.props.pushAssessmentsToStore(selected)
    }
  }

  handleChaptersChange = event => {
    if (event.target.checked) {
      this.props.pushChaptersToStore([
        ...this.props.selectedChapters,
        event.target.value,
      ])
    } else {
      let selected = [...this.props.selectedChapters]
      let index = selected.indexOf(event.target.value)
      selected.splice(index, 1)
      this.props.pushChaptersToStore(selected)
    }
  }

  render() {
    const needsRequirements =
      this.props.selectedAssessments.length === 0 &&
      this.props.selectedChapters.length === 0
    return (
      <div>
        <WizardSteps
          edit={this.props.retrievedEditData}
          step={2}
          linkPaths={linkPaths}
          heading="Certificate"
          subHeading="Define Requirements"
        />
        <div className="requirements-container">
          <form>
            <MultiSelect
              label="Required Assessments: "
              onSelected={this.handleAssessmentsChange}
              contentArray={Object.keys(this.props.assessments).map(pk => ({
                name: this.props.assessments[pk],
                checked: this.props.selectedAssessments.includes(pk) === true,
                id: pk,
              }))}
            />
            <div className="form-row">
              <div className="form-label">
                <label className="fs-xl" htmlFor="passing-score">
                  Lowest Passing Score:
                </label>
              </div>
              <div className="field">{this.generateSelectField()}</div>
            </div>
            <MultiSelect
              label="Required Content: "
              onSelected={this.handleChaptersChange}
              contentArray={this.props.chapters.map(obj => ({
                name: obj.title,
                checked: this.props.selectedChapters.includes(obj.id) === true,
                id: obj.id,
              }))}
            />
          </form>
          <div className="btn_container">
            <Button bsStyle="primary" onClick={this.goBack}>
              Back
            </Button>
            <Button
              bsStyle="primary"
              disabled={needsRequirements}
              onClick={this.goNext}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    passingScore: state.certInfo.passingScore,
    assessments: state.assessments,
    chapters: state.chapters.chapterChoices,
    selectedAssessments: state.certInfo.selectedAssessments,
    selectedChapters: state.certInfo.selectedChapters,
    retrievedEditData: state.certInfo.retrievedEditData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updatePassingScore: passingScore => {
      dispatch(pushPassingScore(passingScore))
    },
    getAssessments: coursenum => {
      dispatch(getAssessmentsJson(coursenum))
    },
    pushAssessmentsToStore: actionObj => {
      dispatch(pushAssessments(actionObj))
    },
    pushChaptersToStore: actionObj => {
      dispatch(pushChapters(actionObj))
    },
    getChapters: coursenum => {
      dispatch(getChaptersJson(coursenum))
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Requirements)
)
